export const MegaBytes = 1024*1024;
export const KiloBytes = 1024;
